import React from 'react';
import HintWrapper from '../HintWrapper';
import './PokemonHint.scss';

const PokemonHint = ({ attemptsCount, currentPokemon, gameWon, isHintRevealed, onRevealHint }) => {
  return (
    <HintWrapper
      attemptsCount={attemptsCount}
      currentItem={currentPokemon}
      gameWon={gameWon}
      isHintRevealed={isHintRevealed}
      onRevealHint={onRevealHint}
      cssPrefix="pokemon-game"
      hintProperty="hint"
      hintLabel="Description"
      showPostWinHint={true}
      unlockThreshold={5}
    >
      {/* Custom content renderer for hint */}
      <div className="pokemon-game__hint-content">
        <strong>Description:</strong> {currentPokemon?.hint || 'No description available.'}
      </div>
    </HintWrapper>
  );
};

export default PokemonHint;